import React from 'react';
import {useNavigate} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import Dropdown, {DropdownItem} from "components/Dropdown";
import {PencilIcon, TrashIcon} from "@heroicons/react/solid";
import {InteractionArea} from "../../../types/InteractionArea";

// Types ----

type InteractionAreaContextMenuProps = {
  interactionArea: InteractionArea
  onDeleteInteractionArea: () => void
  editDisabled?: boolean
  deleteDisabled?: boolean
  position?: 'left' | 'right'
}

// Component ----

function SiteContextMenu({deleteDisabled, onDeleteInteractionArea, editDisabled, interactionArea, position = 'right'}: InteractionAreaContextMenuProps) {
  const navigate = useNavigate();
  const auth = useAuth();

  function editInteractionArea() {
    void navigate(`/interaction-areas/${interactionArea.id}/edit`)
  }

  return (
    <Dropdown position={position}>
      {auth.can('interaction-areas:write') &&
        <DropdownItem name="Edit" icon={PencilIcon} onClick={editInteractionArea} disabled={!!editDisabled}/>
      }

      {auth.can('interaction-areas:write') &&
        <DropdownItem name="Delete" icon={TrashIcon} onClick={onDeleteInteractionArea} disabled={!!deleteDisabled}/>
      }
    </Dropdown>
  );
}

export default SiteContextMenu;